import React, { useCallback, useState } from "react";
import { Alert, Button, Dialog, DialogContent, Grid, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ProformaEmployeeCostReportDTO } from "../../models/proforma-employee-cost-report/proforma-employee-cost-report-dto";
import { ProformaEmployeeCostReportApiService } from "../../services/proforma-employee-cost-report/proforma-employee-cost-report-api.service";
import DialogTitle from "../../containers/DialogTitle/DialogTitle";
import LoadingOverlay from "../../containers/LoadingOverlay/LoadingOverlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import DialogActions from "../../containers/DialogActions/DialogActions";
import { useTranslation } from "react-i18next";

interface Props {
  item: ProformaEmployeeCostReportDTO;
  handleNotify: (signal?: AbortSignal) => Promise<void>;
}

interface State {
  open: boolean;
  loading: boolean;
  error: string;
}

const MarkAsAcceptedByClient = ({ item, handleNotify }: Props) => {
  const tRP = "components.mark_as_accepted_by_client";
  const { t } = useTranslation();
  const theme = useTheme();
  const [state, setState] = useState<State>({
    open: false,
    loading: false,
    error: "",
  });

  const handleMarkAsAcceptedByClient = useCallback(async () => {
    setState((state) => ({ ...state, open: true, loading: true }));
    try {
      const response = await new ProformaEmployeeCostReportApiService().saveItems([
        {
          ...item,
          isAcceptedByClient: true,
        },
      ]);

      if (response.error) {
        setState((state) => ({ ...state, error: response.error }));
      } else {
        // setState((state)=>({...state , open : false}))
        handleNotify && (await handleNotify());
      }
    } catch (error) {
      setState((state) => ({ ...state, error: error }));
    }
  }, [handleNotify, item]);

  return (
    <>
      <Grid style={{ display: "flex", alignItems: "center" }}>
        <Button
          onClick={() => setState((state) => ({ ...state, open: true }))}
          style={{
            color: item.isAcceptedByClient ? theme.palette.secondary.light : theme.palette.text.primary,
            textTransform: "none",
            pointerEvents: "auto",
          }}
          disabled={!!item.isAcceptedByClient}
          title={
            item.isAcceptedByClient
              ? `${t(`${tRP}.button_title_if_accepted_by_client`)}`
              : `${t(`${tRP}.button_title`)}`
          }
        >
          {`${t(`${tRP}.button_title`)}`}
        </Button>
        {item.isAcceptedByClient && (
          <Tooltip title={`${t(`${tRP}.button_title_if_accepted_by_client`)}`}>
            <span>
              <FontAwesomeIcon
                icon={faCircleCheck}
                color={theme.palette.success.main}
              />
            </span>
          </Tooltip>
        )}
      </Grid>

      <Dialog
        open={state.open}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          title={`${t(`${tRP}.dialog_title`)}`}
          handleClose={() => setState((state) => ({ ...state, open: false }))}
        />
        <DialogContent>
          <Typography>{`${t(`common_words.description`)} : ${item.description}`}</Typography>
          {/* <Typography>
            <b>Employee :</b> {item.employee ?? "<MISSING EMPLOYEE NAME>"}
          </Typography>
          <Typography>
            <b>Project :</b> {item.project ?? "<MISSING PROJECT NAME>"}
          </Typography> */}
          <br />
          {state.loading ? (
            <LoadingOverlay loading={state.loading}>
              <Typography>{`${t(`${tRP}.loading_message`)}`}</Typography>
            </LoadingOverlay>
          ) : state.error ? (
            <Alert severity="error">{state.error}</Alert>
          ) : !item.isAcceptedByClient ? (
            <Typography> {`${t(`${tRP}.close_confirm`)}`}</Typography>
          ) : (
            ""
          )}
        </DialogContent>
        <DialogActions
          handleCancel={() => setState((state) => ({ ...state, open: false }))}
          handleSave={handleMarkAsAcceptedByClient}
          customSaveName={`${t(`${tRP}.confirm_button`)}`}
        />
      </Dialog>
    </>
  );
};
export default MarkAsAcceptedByClient;
